import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Space, Select, Switch } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import ThemeSetting from "components/pickers/theme-setting"
import LandingPickerModal from './LandingPickerModal';
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import { useWorkSpace } from 'contexts/workspace';
const service = new StoreSettingService();

const WebsiteSetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify, message } = useApp();
    const { workspace } = useWorkSpace();
    const [oldSetting, setOldSetting] = useState({})
    const [landingModalOpen, setLandingModalOpen] = useState(false)
    const [landingItems, setLandingItems] = useState([])
    const [landingKeyword, setLandingKeyword] = useState("")
    const [activeMenuIndex, setActiveMenuIndex] = useState(-1)
    const [landingLoading, setLandingLoading] = useState(false)
    const websiteUrl = String(workspace?.websiteUrl || '').replace(/\/$/, '');
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        var setting = await service.getWebsiteSetting();
        form.setFieldsValue({
            theme_layout: "base",
            ...setting,
        });
        setOldSetting(setting);
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        showLoading(true);
        try {
            await service.saveWebSiteSetting(values)
            await loadData();
            showNotify("Đã cập nhật")
        } catch (error) {
            message.error("Không thể nhật")
        }
        showLoading(false);

    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    const loadLandingPages = async (keyword = "") => {
        setLandingLoading(true)
        try {
            const result = await service.getSEOLandingPages({
                status: "",
                keyword,
                page: 1,
                page_size: 200,
            })
            setLandingItems(Array.isArray(result?.items) ? result.items : [])
        } catch (error) {
            message.error(error?.message || "Không thể tải danh sách landing page")
        }
        setLandingLoading(false)
    }

    const openLandingPicker = async (menuIndex) => {
        setActiveMenuIndex(menuIndex)
        setLandingModalOpen(true)
        await loadLandingPages(landingKeyword)
    }

    const applyLandingToMenu = (record) => {
        const slug = String(record?.slug || "").trim()
        if (!slug || activeMenuIndex < 0) {
            return
        }

        const menus = Array.isArray(form.getFieldValue("menus")) ? [...form.getFieldValue("menus")] : []
        const current = menus[activeMenuIndex] || {}
        menus[activeMenuIndex] = {
            ...current,
            title: current?.title || record?.title || "",
            url: `/blog/${encodeURIComponent(slug)}`,
        }

        form.setFieldsValue({ menus })
        setLandingModalOpen(false)
    }

    return (


        <Form
            form={form}
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >
            <Form.Item
                label="Link"
                name="url"
                rules={[{
                    required: true,

                },
                {

                    pattern: /^[0-9a-z]{5,30}$/,
                    message: 'Url từ 5 đến 30 ký tự chỉ số và chữ'
                },
                {
                    validator: async (_, value) => {

                        return new Promise(async (r, e) => {

                            try {
                                var data = await service.checkSiteUrl(value);
                                if (data.error) {
                                    e(new Error(data.error));
                                    return;
                                }
                                r();

                            } catch (error) {

                                e(new Error('Không thể kiểm tra'));
                            }

                        })




                    },
                }
                ]}
            >
                <Input addonBefore="shop" suffix={<> <Space>.sipro.app <Button type='link' disabled={!websiteUrl} onClick={e => window.open(websiteUrl)}>Xem</Button> <Button disabled={!websiteUrl} onClick={e => window.navigator.clipboard.writeText(websiteUrl)}>Copy</Button> </Space>  </>} />
            </Form.Item>

            <Form.Item
                label="Tiêu đề"
                name="title"
                rules={[{ required: true, message: 'Please input your website!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Hình ảnh"
                name="image"
                rules={[]}
            >
                <ImagePicker ></ImagePicker>
            </Form.Item>


            <Form.Item
                label="Mô tả"
                name="description"
                rules={[]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Màu sắc"
                name="theme"
                rules={[]}
            >
                <ThemeSetting />
            </Form.Item>

            <Form.Item
                label="Theme layout"
                name="theme_layout"
                initialValue="base"
                rules={[{ required: true, message: 'Vui lòng chọn theme layout' }]}
            >
                <Select
                    options={[
                        { label: "Base", value: "base" },
                        { label: "Custom1", value: "custom1" },
                    ]}
                />
            </Form.Item>




            <Form.Item
                label="Bật chat"
                name="chat_enabled"
                valuePropName="checked"
                tooltip="Tắt để ẩn toàn bộ tính năng chat trên website bán hàng"
            >
                <Switch checkedChildren="Bật" unCheckedChildren="Tắt" />
            </Form.Item>

            <Form.Item
                label="Link chat"
                name="chat_url"
                tooltip={<>
                    Có thể dùng Zalo hoặc Facebook
                    <div>Zalo : https://zalo.me/số_điện_thoại</div>
                    <div>Facebook : http://m.me/PAGE-NAME</div>
                </>}
                rules={[]}
            >
                <Input />
            </Form.Item>


            <Form.Item
                label="Địa chỉ "
                name="address"
                rules={[]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Kiểu đăng nhập"
                name="login_method"
                initialValue="otp"
            
                rules={[{ required: true, message: 'Vui lòng chọn phương thức đăng nhập' }]}
            >
                <Select
                    options={[
                        { label: "OTP qua số điện thoại", value: "otp" },
                        { label: "Tài khoản và mật khẩu", value: "account" },
                        { label: "OTP + tài khoản", value: "both" },
                    ]}
                />
            </Form.Item>

            <Form.Item
                label="Hiển thị giá công khai"
                name="public_price_display"
                valuePropName="checked"
                tooltip="Bật để khách chưa đăng nhập vẫn xem được giá sản phẩm"
            >
                <Switch checkedChildren="Bật" unCheckedChildren="Tắt" />
            </Form.Item>

            <Form.List name="menus">
                {(fields, { add, remove }) => (
                    <Form.Item label="Menu điều hướng">
                        <Space direction="vertical" style={{ width: '100%' }} size={8}>
                            {fields.map(({ key, name, ...restField }) => (
                                <Space key={key} style={{ display: 'flex', width: '100%' }} align="baseline">
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'title']}
                                        rules={[{ required: true, message: 'Nhập tên menu' }]}
                                        style={{ flex: 1, marginBottom: 0 }}
                                    >
                                        <Input placeholder="Tên menu (vd: Landing Combo Sỉ)" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'url']}
                                        rules={[{ required: true, message: 'Nhập link menu' }]}
                                        style={{ flex: 2, marginBottom: 0 }}
                                    >
                                        <Input placeholder="Link (vd: /blog/landing-combo-si hoặc https://...)" />
                                    </Form.Item>
                                    <Button onClick={() => openLandingPicker(name)}>
                                        Chọn landing
                                    </Button>
                                    <Button danger icon={<MinusCircleOutlined />} onClick={() => remove(name)} />
                                </Space>
                            ))}
                            <Button type="dashed" icon={<PlusOutlined />} onClick={() => add({ title: '', url: '' })}>
                                Thêm menu
                            </Button>
                        </Space>
                    </Form.Item>
                )}
            </Form.List>

            <Form.Item label={null}>
                <Button type="primary" htmlType="submit">
                    Cập nhật
                </Button>
            </Form.Item>

            <LandingPickerModal
                open={landingModalOpen}
                onCancel={() => setLandingModalOpen(false)}
                keyword={landingKeyword}
                onKeywordChange={setLandingKeyword}
                onSearch={(value) => {
                    setLandingKeyword(value)
                    loadLandingPages(value)
                }}
                loading={landingLoading}
                items={landingItems}
                onSelect={applyLandingToMenu}
            />
        </Form>
    )
}
export default WebsiteSetting;